export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/f974ae4a89bf06aece5244b03610bc1c/67d4a47a73eb7dfe4f32d22f6de2eeea.png"
          alt="Quality Construction"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full pt-16 lg:pt-0">
        <div className="max-w-3xl">
          {/* Main Headline */}
          <h1 className="text-4xl lg:text-7xl font-bold text-white mb-4 lg:mb-6 leading-tight">
            Building Quality.<br />
            Delivering Trust.<br />
            Every Project.
          </h1>

          {/* Subtitle */}
          <p className="text-base lg:text-lg text-gray-200 mb-8 lg:mb-10 max-w-xl leading-relaxed">
            Professional construction and remodeling services for residential and commercial projects across the United States
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-8 lg:mb-16">
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-brand text-white px-8 lg:px-10 py-4 rounded-xl text-base font-semibold hover:bg-brand-dark transition-all hover:scale-105 whitespace-nowrap"
            >
              Get Free Estimate
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className="bg-transparent border-2 border-white text-white px-8 lg:px-10 py-4 rounded-xl text-base font-semibold hover:bg-white hover:text-gray-900 transition-all whitespace-nowrap"
            >
              View Our Work
            </button>
          </div>

          {/* Trust Indicators */}
          <div className="hidden sm:flex flex-wrap gap-4 lg:gap-6">
            <div className="flex items-center space-x-3 bg-white/10 backdrop-blur-sm px-4 lg:px-6 py-3 rounded-lg">
              <div className="w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center">
                <i className="ri-award-line text-xl lg:text-2xl text-brand"></i>
              </div>
              <span className="text-white font-medium text-sm whitespace-nowrap">12+ Years Experience</span>
            </div>
            <div className="flex items-center space-x-3 bg-white/10 backdrop-blur-sm px-4 lg:px-6 py-3 rounded-lg">
              <div className="w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center">
                <i className="ri-shield-check-line text-xl lg:text-2xl text-brand"></i>
              </div>
              <span className="text-white font-medium text-sm whitespace-nowrap">Licensed & Bonded</span>
            </div>
            <div className="flex items-center space-x-3 bg-white/10 backdrop-blur-sm px-4 lg:px-6 py-3 rounded-lg">
              <div className="w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center">
                <i className="ri-star-line text-xl lg:text-2xl text-brand"></i>
              </div>
              <span className="text-white font-medium text-sm whitespace-nowrap">5-Star Rated</span>
            </div>
          </div>
        </div>
      </div>

      {/* Statistics Card */}
      <div className="hidden lg:block absolute bottom-20 right-20 bg-black/60 backdrop-blur-md rounded-2xl p-8 w-64">
        <div className="space-y-6">
          <div>
            <div className="text-4xl font-bold text-white mb-1">30+</div>
            <div className="text-sm text-gray-300">Projects Completed</div>
          </div>
          <div className="border-t border-white/20"></div>
          <div>
            <div className="text-4xl font-bold text-white mb-1">98%</div>
            <div className="text-sm text-gray-300">Client Satisfaction</div>
          </div>
        </div>
      </div>
    </section>
  );
}
